import { Part, PartProduct, ProductSpecCode, ProductSpecs } from '../types/productSchema';
import { AkbShortSpecs, DisksShortSpecs, TruckTyresShortSpecs, TyresShortSpecs, TyresShortSpecsAddSpikes } from '../const/ShortSpecsByType';
import { sortShortSpecProductTyres, sortShortSpecProductDisks, sortSpecProductAkb } from '@entities/Product/module/helper/sortSpecProduct';

export const getShortFeatures = (part: Part | PartProduct, array: ProductSpecs[]): ProductSpecs[] => {
  switch (part) {
    case Part.Tyres:
    case Part.MotoTires: {
      let newArray = array;
      const spikes = newArray?.find(x => x.code === ProductSpecCode.Season)?.value === '1';
      const runFlat = newArray?.find(x => x.code === ProductSpecCode.RunFlat)?.value === '1';
      newArray = spikes
        ? newArray?.filter(x => TyresShortSpecsAddSpikes.includes(x.code))
        : newArray?.filter(x => TyresShortSpecs.includes(x.code));

      newArray = runFlat ? newArray : newArray?.filter(x => x.code !== ProductSpecCode.RunFlat);

      return newArray.sort(sortShortSpecProductTyres);
    }
    case Part.TruckTires:
      return array.filter(x => TruckTyresShortSpecs.includes(x.code));
    case Part.Disks:
      return array?.filter(x => DisksShortSpecs.includes(x.code)).sort(sortShortSpecProductDisks);
    case Part.Batteries:
      return array?.filter(x => AkbShortSpecs.includes(x.code)).sort(sortSpecProductAkb);
    default:
      return array;
  }
};
